import { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext({ theme: 'dark', toggle: () => {} });

function storageSafeGet(key) {
  try { return localStorage.getItem(key); } catch { return null; }
}

function storageSafeSet(key, value) {
  try { localStorage.setItem(key, value); } catch { /* storage blocked */ }
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(
    () => storageSafeGet('doar_theme') || 'dark'
  );

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    storageSafeSet('doar_theme', theme);
  }, [theme]);

  const toggle = () => setTheme(t => (t === 'dark' ? 'light' : 'dark'));

  return (
    <ThemeContext.Provider value={{ theme, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
